import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getProviders,
    createProvider,
    updateProvider,
    deleteProvider
}

function getProviders(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/providers`)
           .set('access', Storage.getItem('access'))
           .query({userId})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createProvider(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/providers`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateProvider(providerId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/providers/${providerId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function deleteProvider(providerId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/providers/${providerId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}